import { useCallback, useEffect } from 'react';

import CustomForm from '../../common/CustomForm/CustomForm';
import CustomInput from '../../common/CustomInput/CustomInput';
import { useToast } from '../../core/context/toast.context';
import { useUserContext } from '../../core/context/user.context';
import { isEmpty, isValidEmail } from '../../core/helpers';
import useFetch from '../../core/hooks/useFetch';
import { useFormInput } from '../../core/hooks/useFormInput';

const BASE_URL = process.env.REACT_APP_SC_API_BASE;

function Profile() {
  const { user, getUser } = useUserContext();
  const firstname = useFormInput(user.firstname || '', (value) => !isEmpty(value));
  const lastname = useFormInput(user.lastname || '', (value) => !isEmpty(value));
  const email = useFormInput(user.email || '', (value) => isValidEmail(value));
  const phone = useFormInput(user.phone || '', () => true);
  const countryCode = useFormInput(user.phone_country_code || '', () => true);
  const { result, doFetch, loading, error } = useFetch(`${BASE_URL}/user`);
  const { pushToast } = useToast();

  useEffect(() => {
    if (!error) return;
    pushToast(error.message, 'error');
  }, [error]);

  useEffect(() => {
    if (!result) return;
    getUser();
    pushToast('Profile updated!', 'success');
  }, [result]);

  const updateUser = useCallback(() => {
    doFetch({
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify({
        firstname: firstname.value,
        lastname: lastname.value,
        email: email.value,
        phone: phone.value,
        phone_country_code: countryCode.value,
      }),
    });
  }, [firstname.value, lastname.value, email.value, phone.value, countryCode.value]);

  return (
    <section>
      <div className="wrap">
        <div className="form-container">
          <h1 className="h3" style={{ marginBottom: '20px' }}>
            Profile
          </h1>
          <CustomForm onSubmit={updateUser} inputs={[firstname, lastname, email]}>
            <>
              <CustomInput
                id="firstname"
                name="firstname"
                placeholder="First name"
                input={firstname}
                label="First name"
                emptyMessage="Please fill in you first name"
              />
              <CustomInput
                id="lastname"
                name="lastname"
                placeholder="Last name"
                input={lastname}
                label="Last name"
                emptyMessage="Please fill in you last name"
              />
              <CustomInput
                id="email"
                name="email"
                placeholder="Email"
                input={email}
                label="Email"
                emptyMessage="Please fill in you email address"
                invalidMessage="Please fill in a valid email address"
              />
              <CustomInput
                id="phone"
                name="phone"
                placeholder="Phone number"
                input={phone}
                label="Phone number"
                type="number"
              />
              <CustomInput
                id="phone_country_code"
                name="phone_country_code"
                placeholder="Country code"
                input={countryCode}
                label="Country code"
                type="number"
              />
              <button className="btn btn--blue" type="submit" disabled={loading}>
                {loading ? 'Submiting...' : 'Submit'}
              </button>
            </>
          </CustomForm>
        </div>
      </div>
    </section>
  );
}

export default Profile;
